/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo } from './FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo,
    FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail
 * 
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail = FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo;

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo);
    }

    return {};
}

